import {
  CriteriaWithPagination,
  EuiButtonIcon,
  EuiFlexGroup,
  EuiFlexItem,
} from "@elastic/eui";
import {
  Box,
  Button,
  Flex,
  Grid,
  Input,
  LoadingOverlay,
  Title,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BreadCrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import {
  isNullOrUndefined,
  isNullOrUndefinedArry,
} from "../../../_base/extension/StringExtension";
import Repository from "../../../_base/helper/HttpHelper";
import { ParamSearchBase } from "../../../_base/model/_base/ParamSearchBase";
import AppAction from "../../../common/AppAction";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import { BASE_API_URL } from "../../../config";
import { _localization } from "../../../config/location";
import { API_ROUTE } from "../../../const/apiRoute";
import { MessageResponse } from "../../../model/MessageResponse";
import { TblConfigGroup } from "../../../model/TblConfigGroup";
import CreateView from "./CreateView";
import DeleteView from "./DeleteView";
import { IconSearch } from "@tabler/icons-react";

const ConfigGroup = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>();
  const [selectedOptions, setSelected] = useState();
  const [paramSearch, setParamSearch] = useState<ParamSearchBase>();
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [globalSelection, setGlobalSelection] = useState<MRT_RowSelectionState>(
    {}
  );
  const [datas, setDatas] = useState<TblConfigGroup[]>([]);
  const [total, setTotal] = useState(0);
  const [height, setHeight] = useState(0);
  const [rowCount, setRowCount] = useState(0);

  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";

  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: _searchJson?.pageIndex ?? 0,
    pageSize: _searchJson?.pageSize ?? 20,
  });
  const paginationRef = React.useRef<MRT_PaginationState>({
    pageIndex: _searchJson?.pageIndex ?? 0,
    pageSize: _searchJson?.pageSize ?? 20,
  });
  const isInitialized = React.useRef(false);
  const sizeGrid = { base: 6, sm: 4, md: 3, lg: 3, xl: 2 };
  const [visible, { toggle, close, open }] = useDisclosure(false);
  const formSeachInput = useForm({
    mode: "uncontrolled",
    initialValues: {
      KeySearch: _searchJson && checkedPinSearch ? _searchJson?.KeySearch : "",
    },
  });
  const columns = React.useMemo<MRT_ColumnDef<TblConfigGroup>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 100,
      },
      {
        accessorKey: "name",
        header: "Danh sách biến thể sản phẩm",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
        size: 350,
      },
      {
        accessorKey: "lastUpdateBy",
        header: "Người cập nhật",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "creationDate",
        header: "Ngày tạo",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
        sortingFn: (a, b) => {
          const dateA = new Date(a.original.creationDate || 0);
          const dateB = new Date(b.original.creationDate || 0);
          return dateA.getTime() - dateB.getTime();
        },
      },
      {
        accessorKey: "description",
        header: "Mô tả tóm tắt",
        size: 350,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "Actions",
        header: "Thao tác",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableResizing: false,
        size: 100,
        Cell: ({ renderedCellValue, row }) => {
          const online = row.original;
          return (
            <>
              <EuiFlexGroup
                responsive={true}
                wrap={false}
                gutterSize="s"
                alignItems="center"
              >
                <EuiFlexItem grow={false}>
                  <EuiButtonIcon
                    iconType="documentEdit"
                    aria-label="Dashboard"
                    color="success"
                    onClick={(e: any) => {
                      if (isNullOrUndefined(online))
                        NotificationExtension.Warn(
                          "Xin vui lòng chọn dữ liệu !"
                        );
                      else {
                        editItem(online.id);
                      }
                    }}
                  />
                </EuiFlexItem>
                <EuiFlexItem grow={false}>
                  <EuiButtonIcon
                    iconType="trash"
                    color="danger"
                    onClick={(e: any) => {
                      if (isNullOrUndefined(online))
                        NotificationExtension.Warn(
                          "Xin vui lòng chọn dữ liệu !"
                        );
                      else {
                        deleteItem([online.id]);
                      }
                    }}
                  />
                </EuiFlexItem>
              </EuiFlexGroup>
            </>
          );
        },
      },
    ],
    []
  );

  const handleEditData = async (id: number) => {
    if (id) {
      editItem(id);
    } else {
      NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
    }
  };

  const onTableChange = async ({
    page: { index, size },
  }: CriteriaWithPagination<any>) => {
    setPagination({
      ...pagination,
      pageIndex: index,
      pageSize: size,
      // totalItemCount: 1000,
    });
  };

  const onChange = (selectedOptions: any) => {
    setSelected(selectedOptions);
    if (!isNullOrUndefinedArry(selectedOptions)) {
      const value = selectedOptions[0].value;
      if (!isNullOrUndefined(value))
        setParamSearch({ ...paramSearch, inActive: value });
    } else setParamSearch({ ...paramSearch, inActive: undefined });
  };

  const onChangeText = (event: React.ChangeEvent<HTMLInputElement>) => {
    const key = event?.target?.value;
    if (!isNullOrUndefined(key))
      setParamSearch({ ...paramSearch, keyWord: key });
  };

  const openModal = () =>
    modals.openConfirmModal({
      title: (
        <>
          <div color="white">
            <Title order={5}>Thêm mới biến thể sản phẩm</Title>
          </div>
        </>
      ),
      children: (
        <CreateView
          onSearch={() =>
            fetchDataConfigGroup(
              paginationRef.current.pageIndex,
              paginationRef.current.pageSize,
              paramSearch?.keyWord,
              paramSearch?.inActive
            )
          }
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      closeOnClickOutside: false,
      closeOnEscape: false,
      withCloseButton: false,
    });

  // const openModalDelete = () => {
  //   if (isSelectedItem && isSelectedItem.length < 1)
  //     NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
  //   else {
  //     const ids = isSelectedItem;
  //     deleteItem(ids.map((item) => item?.id));
  //   }
  // };

  const openModalDelete = () => {
    // Lấy các ID của row được chọn
    const selectedIds = Object.keys(rowSelection)
      .filter((key) => rowSelection[key])
      .map((key) => datas[parseInt(key)].id);

    if (selectedIds.length === 0) {
      NotificationExtension.Warn("Xin vui lòng chọn dữ liệu để xóa!");
      return;
    }

    deleteItem(selectedIds);
  };

  function deleteItem(idItem: number[]) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Xóa nhóm cấu hình sản phẩm</Title>
        </>
      ),
      children: (
        <DeleteView
          onSearch={() =>
            fetchDataConfigGroup(
              paginationRef.current.pageIndex,
              paginationRef.current.pageSize,
              paramSearch?.keyWord,
              paramSearch?.inActive
            )
          }
          idItem={idItem}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function editItem(id: number) {
    navigate("/product-manager/config-group/edit", { state: { id: id } });
  }

  const fetchDataConfigGroup = async (
    index: number,
    size?: number,
    keyWord?: string,
    inActive?: boolean
  ) => {
    setLoading(true);
    setDatas([]);
    setError(undefined);
    const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
    try {
      let urlSearch = `${API_ROUTE.GET_LIST_CONFIG_GROUP}?Skip=${
        index * (size ?? 0)
      }&Take=${size}`;

      if (formSeachInput.getValues().KeySearch)
        urlSearch += `&KeySearch=${formSeachInput.getValues().KeySearch}`;

      if (!isNullOrUndefined(inActive))
        urlSearch = urlSearch + `&Active=` + inActive;

      let callapi = await repository.get<MessageResponse<any[]>>(urlSearch);
      if (isNullOrUndefined(callapi) || isNullOrUndefinedArry(callapi?.data)) {
        setTotal(0);
      } else {
        setDatas(callapi?.data ?? []);
        setPagination({
          ...pagination,
        });
        setRowCount(callapi?.totalCount ?? 0);
      }
      return callapi?.data;
    } catch (error: any) {
      setError("Có lỗi xảy ra khi tải dữ liệu !");
      return null;
    } finally {
      setLoading(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...formSeachInput.getValues(),
          pageSize: size ?? pagination.pageSize,
          pageIndex: index,
        })
      );
    }
  };
  const fetchData = async () => {
    setRowSelection({});
    await fetchDataConfigGroup(
      pagination.pageIndex,
      pagination.pageSize,
      paramSearch?.keyWord,
      paramSearch?.inActive
    );
  };

  useEffect(() => {
    paginationRef.current = pagination;
    if (isInitialized.current) {
      fetchData();
    }
  }, [pagination.pageIndex, pagination.pageSize]);

  useEffect(() => {
    // Reset row selection khi chuyển trang hoặc data thay đổi
    setRowSelection({});
  }, [pagination.pageIndex, pagination.pageSize, datas]);

  const exportExcel = async () => {
    open(); // Hiển thị loading
    try {
      // Khởi tạo URL với các tham số phân trang
      const params = new URLSearchParams();

      // Thêm thông tin phân trang
      params.append(
        "Skip",
        (pagination.pageIndex * pagination.pageSize).toString()
      );
      params.append("Take", pagination.pageSize.toString());

      // Lấy giá trị từ form và thêm vào params nếu có giá trị
      const { KeySearch } = formSeachInput.getValues();
      if (KeySearch) params.append("KeySearch", KeySearch);
      // Xây dựng URL API cuối cùng
      const baseUrl = `/ExportExcel/export-product-config-groups?${params.toString()}`;

      const _url = BASE_API_URL + baseUrl;
      const fullUrl = new URL(_url);
      const token = localStorage.getItem("token");

      // Gọi API
      const response = await fetch(fullUrl.toString(), {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token?.replace(/"/g, "")}`,
          "Content-Type": "application/vnd.ms-excel",
        },
      });
      // Kiểm tra trạng thái HTTP
      if (!response.ok) {
        const errorResponse = await response.json(); // Parse lỗi từ API
        const errorMessage =
          errorResponse?.message || "Đã xảy ra lỗi khi xuất dữ liệu!";
        throw new Error(errorMessage); // Ném lỗi để xử lý trong `catch`
      }

      // Xử lý file Excel
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const filename = "nhom-cau-hinh-san-pham.xlsx"; // Tên mặc định nếu không có header
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error: any) {
      console.error("Error:", error);
      // Hiển thị thông báo lỗi
      NotificationExtension.Fails(
        error.message || "Đã xảy ra lỗi không xác định!"
      );
    } finally {
      close(); // Đóng loading
    }
  };
  const table = useMantineReactTable({
    columns,
    data: datas || [],
    enableColumnResizing: true,
    enableTopToolbar: false,
    autoResetPageIndex: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,

    enableRowSelection: true,
    onRowSelectionChange: setRowSelection,
    state: {
      pagination,
      rowSelection, // Thêm rowSelection vào state
    },
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select"],
        right: ["Actions"],
      },
      columnVisibility: { id: true },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height - 100, minHeight: height - 100 },
    },
    enableStickyHeader: true,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "550",
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    positionToolbarAlertBanner: "bottom",
  });

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 190 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (130 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      isInitialized.current = true;
      fetchData();
    }, 0);
  }, []);

  return (
    <>
      <Flex
        justify="space-between"
        align="center"
        style={{
          border: "1px solid #dee2e6",
          padding: "5px 10px",
        }}
      >
        <BreadCrumb />
        <AppAction
          openModal={openModal}
          openModalDelete={openModalDelete}
          exportExcel={exportExcel}
        ></AppAction>
      </Flex>
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          flexWrap: "wrap",
          // marginTop: "10px",
        }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />
        <Grid style={{ width: "100%" }} mt={10}>
          <Grid.Col span={sizeGrid}>
            <Input
              size="sm"
              placeholder="Từ khoá"
              type="text"
              leftSection={<IconSearch color="#15aabf" />}
              key={formSeachInput.key("KeySearch")}
              {...formSeachInput.getInputProps("KeySearch")}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Button
              type="submit"
              leftSection={<IconSearch size={20} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>{" "}
          </Grid.Col>
        </Grid>
      </Box>
      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

export default ConfigGroup;
